// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import React, { memo } from 'react';
import { IconProps as Props } from '../types';

const SvgWarning: React.FC<Props> = (allProps) => {
  const { fill, primary, secondary, tertiary, quaternary, ...props } = allProps;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      focusable="false"
      aria-hidden="true"
      role="presentation"
      {...props}
    >
      <g fill={primary ?? fill ?? 'currentColor'}>
        <path
          fillRule="evenodd"
          d="M9.417 2.46c1.164-1.947 4.002-1.947 5.166 0l8.991 15.035C24.764 19.483 23.32 22 20.991 22H3.01C.679 22-.763 19.483.426 17.495zm3.461 11.184c-.011.576-.321.887-.872.887-.574 0-.896-.322-.907-.887l-.15-5.85c-.01-.566.425-.976 1.045-.976.609 0 1.068.421 1.056.986zm.367 3.336c0 .643-.585 1.152-1.24 1.152-.665 0-1.239-.52-1.239-1.152 0-.643.563-1.153 1.24-1.153.665 0 1.24.5 1.24 1.153"
          clipRule="evenodd"
        />
      </g>
    </svg>
  );
};

const Memo = memo(SvgWarning);
export default Memo;
